<template>
    <div class="messages-feed" ref="feed">
        <ion-list v-if="contact">
            <ion-button v-if="moreMessages" @click="loadMoreMessages"> {{ $t('master.more') }} ... </ion-button>
            <li
                lines="none"
                v-for="message in allMessages"
                :class="`message ${message.to == contact.id ? 'sent' : 'received'}`"
                :key="message.id"
            >
                <div v-if="message.type == 'txt'" class="message-text">
                    <div v-if="message.title" class="message-title">
                        {{ message.title }}
                    </div>
                    <div v-if="user.has_access" class="message-body">
                        {{ message.message }}
                    </div>
                    <div v-else>
                        <ion-skeleton-text class="skeleton-large"></ion-skeleton-text>
                        <ion-skeleton-text class="skeleton-medium"></ion-skeleton-text>
                        <ion-skeleton-text class="skeleton-small"></ion-skeleton-text>
                    </div>
                    <div style="font-size:11px;direction:ltr;margin-top:5px">{{ message.created_at }}</div>
                </div>
                <div v-if="message.type == 'pic'" class="message-text">
                    <div v-if="message.title" class="message-title">
                        {{ message.title }}
                    </div>
                    <div>
                        <img :src="`${constants.assetsUri}/${message.message}`" />
                    </div>
                </div>
                <div v-if="message.type == 'aud'" class="message-text">
                    <div v-if="message.title" class="message-title">
                        {{ message.title }}
                    </div>
                    <audio-message :message="message" @openPlansPopup="openPlansPopup" />
                </div>
                <div v-if="message.type == 'vid'" class="message-text">
                    <div v-if="message.title" class="message-title">
                        {{ message.title }}
                    </div>
                    <video-message :message="message" @openPlansPopup="openPlansPopup" />
                </div>
            </li>
            <li v-if="sending" class="message sent">
                <div class="message-text">
                    <ion-skeleton-text class="sending-skeleton" animated></ion-skeleton-text>
                </div>
            </li>
        </ion-list>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { constants } from '../constants'
import AxiosController from '@/controllers/AxiosController'
import { setTimeout } from 'timers'
import AudioMessage from '@/components/AudioMessage'
import VideoMessage from '@/components/VideoMessage'

export default {
    components: {
        AudioMessage,
        VideoMessage
    },
    props: ['contact', 'messages', 'sending'],
    data() {
        return {
            constants,
            scroll: true,
            lastId: null,
            loadedMessages: [],
            allMessages: [],
            moreMessages: true
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    mounted() {
        this.scrollToBottom()
        this.allMessages = this.messages
        if (this.allMessages.length > 0) {
            this.lastId = this.allMessages[0].id
        }

        this.moreMessages = this.allMessages.length >= 10
    },
    methods: {
        scrollToBottom: function() {
            setTimeout(() => {
                this.$refs.feed.scrollTop = this.$refs.feed.scrollHeight - this.$refs.feed.clientHeight
            }, 20)
        },
        loadMoreMessages() {
            const params = {
                last_id: this.lastId
            }
            this.scroll = false
            AxiosController.get(`/conversation/${this.contact.id}`, { params }).then(res => {
                const { data } = res
                const newMessages = data.reverse()
                this.lastId = newMessages[0] && newMessages[0].id
                if (!this.lastId || data.length < 10) {
                    this.moreMessages = false
                }
                this.loadedMessages = [...newMessages, ...this.loadedMessages]
                this.allMessages = [...this.loadedMessages, ...this.messages]
            })
        },
        goToPlans() {
            this.$router.push('/plans')
        },
        openPlansPopup() {
            this.$emit('openPlansPopup')
        }
    },
    watch: {
        contact() {
            this.scrollToBottom()
        },
        messages(messages, oldMessages) {
            this.allMessages = messages
            if (this.allMessages.length > 0) {
                this.lastId = this.allMessages[0].id
            }
            this.moreMessages = this.allMessages.length >= 10

            if (this.scroll == false) {
                this.scroll = true
                return
            }
            this.scrollToBottom()
        },
        sending() {
            this.scrollToBottom()
        },
        goToPlans() {
            this.$router.push('/plans')
        }
    }
}
</script>

<style lang="scss">
.messages-feed {
    background: #f0f0f0;
    height: 470px;
    overflow: scroll;
    background: linear-gradient(rgba(0, 44, 70, 0.5), rgba(0, 44, 70, 0.5)), url('~@/assets/chat-bg.jpg');
    background-position: 50% 20%;
    flex: 1;

    ion-list {
        list-style-type: none;
        padding: 5px;
        background: none;

        li {
            &.message {
                margin: 10px 0 25px 0;
                width: 100%;
                // border: none;

                .message-text {
                    max-width: 80%;
                    border-radius: 5px;
                    padding: 12px;
                    display: inline-block;
                    text-align: start;

                    .message-title {
                        font-weight: bold;
                    }

                    .video-player {
                        video {
                            max-width: 100%;
                            max-height: 30vh;
                        }
                    }
                }

                &.received {
                    text-align: left;

                    .message-text {
                        background: #dfd5c1;
                    }
                }
                &.sent {
                    text-align: right;

                    .message-text {
                        background: #b4c7ae;
                    }
                }

                .skeleton-small {
                    width: 65px;
                }
                .skeleton-medium {
                    width: 90px;
                }
                .skeleton-large {
                    width: 120px;
                }
            }
        }
    }
}
.image-subscribe-cta {
    color: blue;
    font-size: 12px;
    max-width: 75%;
    display: inline-block;
    margin: 8px;
}

#app[dir='rtl'] .messages-feed {
    li {
        &.message {
            &.received {
                text-align: right;
            }
            &.sent {
                text-align: left;
            }
        }
    }
}

.vue-sound__extern-wrapper {
    display: none !important;
}
.vue-sound__player {
    display: initial !important;
}

.video-subscribe-cta {
    color: blue;
    font-size: 12px;
    max-width: 75%;
    display: inline-block;
    margin: 8px;
}

@media (min-width: 768px) {
    .message-text {
        font-size: 20px;
    }
}
@media (min-width: 1200px) {
    .messages-feed {
        min-height: 600px;
        max-height: 600px;
        overflow-y: scroll;
        overflow-x: hidden;
    }
}
</style>
